export default function SuccessCheck({ width = 24, height = 24 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#F2FFF9" />
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM18.0455 7.4545C17.6061 7.01517 16.8938 7.01517 16.4545 7.4545C16.4439 7.46511 16.4339 7.47635 16.4247 7.48816L11.2161 14.1251L8.07581 10.9848C7.63647 10.5455 6.92416 10.5455 6.48482 10.9848C6.04548 11.4242 6.04548 12.1365 6.48482 12.5758L10.4545 16.5455C10.8938 16.9848 11.6061 16.9848 12.0455 16.5455C12.0553 16.5357 12.0645 16.5254 12.0731 16.5146L18.0615 9.02921C18.4848 8.58872 18.4794 7.88846 18.0455 7.4545Z"
        fill="#1DB469"
      />
    </svg>
  );
}
